<template>
  <div style="font-size: 14px; line-height: 1.8; color: #333; padding: 15px;">
    <p align="center" style="font-size: 20px; font-weight: bold; margin-bottom: 10px;">
      悄然声色用户服务协议
    </p>
    
    <p align="center" style="font-size: 13px; color: #666; margin-bottom: 20px;">
      更新日期：2026年8月17日 &nbsp;|&nbsp; 生效日期：2026年8月17日
    </p>

    <p style="font-size: 16px; font-weight: bold; margin-top: 15px;">
      欢迎使用悄然声色！
    </p>

    <p>
      悄然声色（以下简称“本平台”或“我们”）是由北京天下在线科技有限公司（以下简称“本公司”）及其关联方合法拥有并运营的声音克隆与声音交易服务平台，包括悄然声色官方网站（https://www.txyapp.com）、悄然声色安卓APP、悄然声色iOS APP以及我们可能推出的其他客户端应用程序（以下统称“本软件”）。在本平台中，我们为用户（以下亦称“您”）提供文字转语音的声音克隆服务、声音交易市场服务以及相关配套服务。
    </p>

    <p style="background-color: #fffbe6; padding: 10px; border-left: 4px solid #ffe58f; margin: 10px 0;">
      <b>特别提示一：</b>根据《中华人民共和国民法典》第一千零二十三条第二款规定，对自然人声音的保护参照适用肖像权保护的有关规定。声纹信息依据《中华人民共和国个人信息保护法》被归类为敏感个人信息，受到严格保护。您在使用本服务时须严格遵守相关法律法规。
    </p>

    <p style="background-color: #fffbe6; padding: 10px; border-left: 4px solid #ffe58f; margin: 10px 0;">
      <b>特别提示二：未经声音权利人合法、完整的书面授权，您不得擅自采集、使用、合成、传播、售卖任何他人的声音（包括但不限于明星、名人、知名配音演员、公众人物及其他任何自然人的声音）。司法实践中已有未经授权使用他人声音被判侵权赔偿的案例，侵权人可能面临停止侵权、赔礼道歉、赔偿损失等法律责任，赔偿金额根据权利人损失或侵权人获利等因素确定，已有判例判决赔偿金额达25万元。</b>
    </p>

    <p>
      <b>请您在开始使用悄然声色之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、限制用户权利的条款、权利许可和信息使用的条款、法律适用和争议解决条款等，我们已将这些重要内容以加粗字体标注，以便于您识别和重点阅读。如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解本协议，尤其是其中的未成年人使用条款，并在征得法定监护人同意后使用本平台。</b>
    </p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">一、导言</p>
    <p><b>1.1</b> 《悄然声色用户服务协议》（以下称“本协议”）是我们与您订立的，就您下载、安装、打开、注册、登录、使用（以下统称“使用”）悄然声色的相关事宜约定双方权利义务的协议。</p>
    <p><b>1.2</b> 请您注意，我们已经发布、后续可能发布的、不时修改的与悄然声色有关的其他相关协议（包括使用单项服务时的协议或平台上传规则等）、公告、说明、站内信通知等（合称“平台规则”）均属于本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
    <p><b>1.3</b> 当您使用悄然声色，则视为您已详细阅读并充分理解本协议的全部内容，同意作为本协议的一方当事人接受本协议的约束。如您不同意本协议，可以选择不使用悄然声色。</p>
    <p><b>1.4</b> 请您理解，我们有权依悄然声色产品、服务或运营的需要单方决定，将本协议项下的某些服务交由我们的关联方或第三方提供或运营。请您在使用该等相关服务时，仔细阅读相应产品页面展示的信息及/或相关规则、协议等文件的内容。</p>
    <p><b>1.5</b> 如对本协议内容有任何疑问、意见或建议，您可通过登录悄然声色官方网站或客户端的反馈与帮助相关页面与我们联系。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">二、悄然声色产品及服务</p>
    <p><b>2.1 功能说明：</b>悄然声色是一款利用语音大模型进行文字转语音的工具，其主要功能包括：（1）声音克隆——用户上传本人声音样本后，通过本平台的大模型技术生成克隆声音，用于有声读物配音、影视讲解配音等场景；（2）声音交易市场——用户可在本平台内上传发布自己的原创声音进行售卖，买家购买后可直接使用所购声音进行有声读物或影视讲解的克隆制作。本平台仅为声音买卖双方提供交易撮合与支付结算服务。</p>
    <p><b>2.2</b> 您使用悄然声色需自行准备如电脑、手机等相关终端设备。为实现悄然声色的全部功能，您需将终端设备联网，您应自行承担所需要的上网费、流量费等费用。</p>
    <p><b>2.3</b> 我们许可您一项个人的、可撤销的、不可转让的、非独占的和非商业的合法使用悄然声色的权利。本协议未明示授权的其他一切权利仍由我们保留。</p>
    <p><b>2.4</b> 为提升用户体验，或基于整体服务运营、平台安全、合规经营的需要，我们可能不定期更新或变更悄然声色产品或服务，包括但不限于修改、升级、中止或终止相关服务、提供新服务或软件包替换等。您可根据需要自行选择是否更新。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">三、账号注册与实名认证</p>
    <p><b>3.1</b> 我们提供悄然声色账号的注册通道，您可以通过移动电话号码或悄然声色允许的其他方式注册账号。注册后，您可以自行设置安全的登录密码。</p>
    <p><b>3.2</b> 您可以在不注册或登录账号时使用悄然声色的部分功能，但无法体验全部功能。在使用某些功能前（如声音克隆、声音交易市场等），您需要注册或登录账号，并按照国家相关法律法规的要求完成真实身份信息认证。</p>
    <p><b>3.3</b> 您有权自行设置悄然声色昵称、头像等账号信息。未经他人明示书面许可，您不得以他人名义开设账号，不得假冒仿冒他人姓名、名称、字号、商标、头像等作为账号信息。</p>
    <p><b>3.4</b> 您的悄然声色账号仅限您本人使用，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。</p>
    <p><b>3.5 为履行反洗钱、反恐怖主义融资等法定义务，本平台对卖家（声音上传与售卖方）实行实名认证制度。</b>您作为卖家申请入驻声音交易市场时，须提交真实有效的身份信息（自然人须提供身份证信息，企业须提供营业执照等资质文件）及支付宝账户信息，并配合平台完成实名核验。未完成实名认证的，不得在市场中发布和售卖声音产品。</p>
    <p><b>3.6</b> 您在注册、使用账号时，应提供真实、准确、合法、有效的身份证明材料及必要信息。当您提交的注册信息发生变更时（例如您更换了手机号），您应及时更新相应信息。</p>
    <p><b>3.7</b> 您应自行维护您的账号、密码的安全性与保密性。您需对您的账号下的行为承担法律责任。如您丢失账号或遗忘密码，可遵照我们的申诉途径及时申请找回账号或密码。因您保管不当等自身原因导致您的账号被盗或密码丢失，相应损失需由您自行承担。</p>
    <p><b>3.8</b> 您可以申请注销账号。账号注销后，我们将对账号内的信息做删除或者匿名化处理。账号注销后，您将无法使用该账号登录本平台，也无法找回账号相关的任何内容或信息。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">四、声音克隆功能使用规则</p>
    <p><b>4.1 声音来源合法</b></p>
    <p><b>4.1.1</b> 您在使用本平台声音克隆功能时，承诺您所提供/上传/输入的全部信息（包括但不限于上传的任何声音样本、音频文件、文本内容等）来源合法合规，不侵犯任何第三方的合法权益（包括但不限于声音权、肖像权等人格权，以及著作权、专利权、商标权等知识产权）。</p>
    <p><b>4.1.2 您保证对其上传的声音样本拥有完整且合法的所有权、使用权或已取得权利人充分、必要且有效的书面授权。如声音样本非您本人，您须依法告知被模仿或采集声音的自然人，并取得其单独、明确的书面同意。</b></p>
    <p><b>4.1.3 您不得上传、克隆或使用任何未经授权的他人的声音，包括但不限于明星、名人、知名配音演员、公众人物及其他任何自然人的声音。</b></p>
    <p><b>4.1.4 AI合成声音的法律地位：您理解并确认，利用本平台生成的AI合成声音，如具有可识别性（即能够让社会公众联想到特定自然人），仍受《中华人民共和国民法典》关于声音权益的保护。即使声音系通过AI技术合成生成，未经声音权利人授权而使用该合成声音，仍可能构成对权利人声音权益的侵权，您应自行承担因此产生的全部法律责任。</b></p>
    <p><b>4.1.5 授权文件要求：</b>如您上传的声音样本涉及他人声音，您应确保所取得的书面授权文件清晰地载明以下内容：（1）授权主体（权利人本人）；（2）被授权主体（您本人）；（3）授权使用的具体声音样本内容；（4）授权使用的具体场景、范围及期限；（5）是否允许商业使用；（6）是否允许转授权。授权链条不完整或不清晰的，视为未取得合法授权。</p>
    
    <p><b>4.2 禁止用途</b><br>您不得利用本服务从事以下活动：</p>
    <p>4.2.1 制作、上传、复制、发布、传送或传播任何违反法律法规的内容，包括但不限于含有色情、淫秽、暴力、恐怖、赌博、毒品、诈骗等违法信息的内容。</p>
    <p>4.2.2 利用克隆声音冒充他人身份进行欺诈、欺骗、诽谤、骚扰或其他非法活动。</p>
    <p>4.2.3 将克隆后的声音用于未经授权的商业用途，或用于误导他人认为合成内容为自然人的真实声音。</p>
    <p>4.2.4 制作、传播虚假新闻信息或其他法律法规禁止的信息内容。</p>

    <p><b>4.3 AI生成内容标识义务</b></p>
    <p><b>4.3.1</b> 根据《人工智能生成合成内容标识办法》及《互联网信息服务深度合成管理规定》，您在使用本服务生成合成内容后，应当在生成合成内容的文件元数据中保留本平台添加的隐式标识，并在对外发布、传播时确保含有满足要求的显式标识。</p>
    <p><b>4.3.2</b> 您将本平台生成的合成内容发布至第三方平台（如抖音、快手等）时，应按照相关法律法规和第三方平台的要求，对合成内容进行显著标识，明确提醒公众该内容属于人工智能生成合成内容，不得将合成内容谎称为自然内容。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">五、声音交易市场（“市场”）使用规则</p>
    <p><b>5.1 卖家（声音上传与售卖方）义务</b></p>
    <p><b>5.1.1 您在市场内上传售卖的声音产品须为您的原创声音，或您已取得权利人完整、合法、有效的书面授权。您不得上传、售卖任何未经授权的他人声音，包括但不限于明星、名人、知名配音演员、公众人物及其他任何自然人的声音。</b></p>
    <p><b>5.1.2 授权链条完整性：</b>如您上传的声音产品涉及他人声音，您须确保授权链条完整、清晰、可追溯。录音制品的著作权授权不等于声音人格权授权，拥有录音制品的著作权并不意味着同时获得了声音权利人的人格权授权。您应确保就声音本身的使用已获得权利人独立、明确的人格权授权。</p>
    <p><b>5.1.3 持有著作权不等于可商用声音：您理解并确认，即使您拥有某一录音制品（如歌曲、有声书录音等）的著作权或使用权，该等权利并不自动包含对录音制品中所含自然人声音的独立使用权。如需将该录音制品中的声音用于声音克隆或AI合成，您仍需另行取得该声音权利人的书面授权。</b></p>
    <p><b>5.1.4</b> 您应确保所售卖的声音产品不侵犯任何第三方的知识产权、人格权（包括声音权、肖像权等）及其他合法权益。您对所上传售卖的声音产品的合法性承担全部法律责任。</p>
    <p><b>5.1.5 授权文件备查：</b>如上传内容涉及他人声音或第三方权利，您应保留相关授权文件原件或复印件，并能在本平台要求时及时提供以供核验。若未能及时提供，本平台有权根据权利人的要求，对涉嫌侵权的内容采取下架、删除等措施，且不承担因此对您造成的任何损失。</p>
    <p><b>5.1.6</b> 您应如实、准确描述声音产品的特征、用途及授权范围，不得进行虚假或引人误解的宣传。</p>
    <p><b>5.1.7</b> 您设定的声音产品价格应合理、真实，不得利用异常定价进行洗钱等违法犯罪活动。</p>

    <p><b>5.2 买家义务</b></p>
    <p><b>5.2.1</b> 您购买市场内声音产品后，仅可在该声音产品所附授权范围内使用，不得超出授权范围进行复制、传播、转让、出售或用于其他商业用途。</p>
    <p><b>5.2.2 购买行为不代表获得人格权授权：您理解并确认，您在本平台支付费用购买声音产品，仅代表获得该声音产品在卖家所声明授权范围内的使用权。该购买行为本身不构成对声音权利人声音人格权的直接授权。如卖家本身未取得声音权利人的合法授权，您的购买和使用行为仍可能构成对声音权利人的侵权，您应自行承担因此产生的全部法律责任。</b></p>
    <p><b>5.2.3 审慎审查义务：您在购买声音产品前，应审慎审查卖家的授权文件及授权范围。如您对声音产品的授权合法性存在疑问，应主动要求卖家出示授权证明文件，或拒绝购买该声音产品。因您未尽审慎审查义务而购买侵权声音产品所产生的一切法律后果，由您自行承担。</b></p>
    <p><b>5.2.4</b> 您使用所购买的声音产品时，同样须遵守本协议第四条关于声音克隆功能的使用规则。</p>

    <p><b>5.3 平台交易服务</b></p>
    <p><b>5.3.1</b> 本平台仅为声音产品的买卖双方提供交易撮合与支付结算服务，不对声音产品的质量、合法性、真实性、准确性作出任何明示或暗示的保证。因声音产品本身引发的任何纠纷，由买卖双方自行解决，本平台不承担任何责任。</p>
    <p><b>5.3.2</b> 买家支付完成后，交易额度将计入卖家账户。本平台将定期通过支付宝将卖家账户中的可提现余额自动转账至卖家实名认证时绑定的支付宝账户。</p>
    <p><b>5.3.3</b> 卖家须确保其绑定的支付宝账户为本人实名账户，且账户信息真实、准确、有效。因账户信息错误、失效或账户异常等原因导致提现失败的，由卖家自行承担相应后果。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">六、上传内容审核</p>
    <p><b>6.1</b> 本平台有权对您上传的全部内容进行审核。审核内容包括但不限于：声音来源合法性、内容合规性、格式规范性、版权合法性等。</p>
    <p><b>6.2</b> 本平台有权根据审核结果决定是否接受您的上传内容。对于不符合本规则的内容，本平台有权拒绝发布、下架或删除。</p>
    <p><b>6.3</b> 审核通过不代表本平台对上传内容的合法性、真实性、准确性作出任何保证，您仍须对上传内容承担全部法律责任。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">七、反洗钱与反欺诈条款</p>
    <p><b>7.1</b> 您不得利用本平台或本服务从事或协助任何洗钱、恐怖主义融资、诈骗、非法集资、赌博等违法犯罪活动。</p>
    <p><b>7.2 您不得通过虚构交易、虚假买卖、自买自卖、频繁异常交易等方式操纵市场交易或进行资金转移。本平台有权对异常交易行为进行监测、调查和限制。</b></p>
    <p><b>7.3</b> 如本平台发现您的账户或交易行为存在洗钱、诈骗等违法犯罪怀疑，本平台有权：（1）立即暂停或终止向您提供全部或部分服务；（2）冻结您的账户资金及交易额度；（3）向有关国家机关报告并移交相关证据材料。</p>
    <p><b>7.4</b> 您应配合本平台及监管部门开展的反洗钱调查工作，按要求提供相关交易信息、身份信息及证明材料。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">八、信息内容发布规范</p>
    <p><b>8.1 您不得制作、复制、发布、传播以下违法违规内容：</b></p>
    <p>（1）反对宪法确定的基本原则的；<br>
    （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
    （3）损害国家荣誉和利益的；<br>
    （4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br>
    （5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br>
    （6）宣扬民族仇恨、民族歧视，破坏民族团结的；<br>
    （7）破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
    （8）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；<br>
    （9）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
    （10）侮辱或者诽谤他人，侵害他人名誉权、隐私权、肖像权、知识产权或其他合法权益的；<br>
    （11）法律、行政法规禁止的其他内容。</p>
    
    <p><b>8.2 您不得制作、复制、发布以下不良内容，亦应当主动抵制此类内容的传播：</b></p>
    <p>（1）使用夸张标题，内容与标题严重不符的；<br>
    （2）炒作绯闻、丑闻、劣迹等的；<br>
    （3）不当评述自然灾害、重大事故等灾难的；<br>
    （4）带有性暗示、性挑逗等易使人产生性联想的；<br>
    （5）展现血腥、惊悚、残忍等致人身心不适的；<br>
    （6）煽动人群歧视、地域歧视等的；<br>
    （7）宣扬低俗、庸俗、媚俗内容的；<br>
    （8）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；<br>
    （9）对他人进行暴力恐吓、威胁，实施网络暴力行为的；<br>
    （10）散布污言秽语，损害社会公序良俗的；<br>
    （11）其他含有违反法律法规、公共政策、公序良俗的内容。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">九、网络安全保护</p>
    <p><b>9.1</b> 您不得使用任何插件、外挂、系统或第三方工具对悄然声色的正常运行进行干扰、破坏、修改或施加其他影响。</p>
    <p><b>9.2</b> 您不得进行任何危害系统安全的行为，亦不得利用本平台从事任何危害计算机网络安全的行为，包括但不限于：<br>
    （1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；<br>
    （2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；<br>
    （3）对悄然声色进行反向工程、反向汇编、编译或者以其他方式尝试发现悄然声色的源代码；<br>
    （4）恶意注册账号，包括但不限于频繁、批量注册账号；<br>
    （5）其他可能危害本平台或其他平台计算机网络安全的行为。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十、违约处理</p>
    <p><b>10.1</b> 如果您违反含平台规则在内的本协议约定，我们有权视情况采取预先警示、拒绝发布、立即停止传输信息、删除内容、限制账号部分或者全部功能，直至终止提供服务、永久关闭账号及法律法规规定的其他处置措施。对已删除的用户信息或内容，我们有权不予恢复。</p>
    <p><b>10.2</b> 我们有权公告处理结果，且有权根据实际情况决定是否恢复相关账号的使用。对涉嫌违法犯罪的行为，我们将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查。</p>
    <p><b>10.3</b> 我们尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。如您侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益，引起第三方投诉、举报或以诉讼等方式维权索赔的，我们有权根据法律法规要求采取必要措施。</p>
    <p><b>10.4 因您的行为（包括但不限于上传侵权声音、未经授权使用他人声音、超出授权范围使用声音产品等）导致我们向任何第三方承担赔偿责任，或遭受国家机关处罚，或受到其他经济损失或商誉损失的，您应赔偿我们因此遭受的全部损失，包括但不限于赔偿款、罚款、律师费、诉讼费、公证费、差旅费等全部合理费用。</b></p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十一、用户个人信息保护</p>
    <p><b>11.1</b> 我们与您一同致力于个人信息的保护。</p>
    <p><b>11.2</b> 保护用户个人信息是我们的基本原则之一。您在使用悄然声色的过程中，可能需要提供您的个人信息，以便我们向您提供更好的服务和相应的技术支持。</p>
    <p><b>11.3 声纹信息属于《中华人民共和国个人信息保护法》所规定的敏感个人信息，我们将依法采取加密技术、匿名化处理及其他与悄然声色产品及服务相匹配的安全技术措施保护您的声纹信息及其他个人信息。</b></p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十二、知识产权</p>
    <p><b>12.1</b> 悄然声色产品和服务的全部知识产权归我们所有，包括但不限于软件、技术、程序、网页、文字、图片、音频、视频、图表、版面设计、电子文档等。</p>
    <p><b>12.2</b> 您理解并承诺，您在使用悄然声色时发布的内容，包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的声音、台词、对话等所有组成部分，均由您原创或已获合法授权。您通过本平台上传、发布所产生内容的知识产权归属您或原始著作权人所有。</p>
    <p><b>12.3</b> 为使您的作品得到更好的分享及推广，提高其传播价值及影响力，对于您通过本平台上传发布的各种形式的内容，您授予我们一项全球范围内、免费、非独家、可多层次再许可的权利，包括修改权、复制权、翻译权、汇编权、信息网络传播权、改编权及制作衍生品、表演和展示的权利等。上述权利的使用范围包括在本平台或其他网站、应用程序或智能终端设备等产品上使用。</p>
    <p><b>12.4</b> 基于部分功能的特性，您通过本平台上传发布的内容及其中包含的声音、音频或对话等，可供其他用户使用本平台创作及发布相关内容时使用。我们将通过本协议或平台规则要求其他用户在此过程中不得侵犯您的合法权益。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十三、未成年人使用条款</p>
    <p><b>13.1 若您是未满18周岁的未成年人，您应在监护人指导下认真阅读本协议，经您的监护人同意本协议后，方可使用悄然声色。</b></p>
    <p><b>13.2</b> 我们重视对未成年人个人信息及隐私的保护。我们特别提醒您在填写未成年人个人信息时应加强保护意识并谨慎发布包含未成年人素材的内容。</p>
    <p><b>13.3</b> 我们将与监护人共同努力，保护未成年人身心健康。如果您是监护人，您亦应履行对未成年人的监护义务，关注未成年人网络安全，引导未成年人健康合理使用网络。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十四、法律后果告知</p>
    <p><b>14.1 侵权责任：您理解并确认，未经声音权利人合法授权而擅自使用、克隆、传播、售卖他人声音的，可能构成对权利人声音权益（人格权）及/或著作权的侵犯。侵权人依法可能承担以下法律责任：</b><br>
    （1）停止侵害、消除影响、赔礼道歉；<br>
    （2）赔偿权利人因此遭受的实际损失或侵权人因此获得的违法所得；<br>
    （3）权利人的实际损失或侵权人的违法所得难以计算的，由人民法院根据侵权行为的情节，判决给予五百万元以下的赔偿；<br>
    （4）赔偿权利人因维权而支出的合理费用，包括但不限于律师费、公证费、诉讼费等。</p>
    <p><b>14.2 司法判例参考：您理解并确认，司法实践中已有未经授权使用他人声音用于AI合成被判侵权赔偿的案例，法院认定即使声音系通过AI技术合成，如具备可识别性，仍受人格权保护，侵权人须承担相应赔偿责任。已有判例确定的赔偿金额包括但不限于25万元等数额。</b></p>
    <p><b>14.3 刑事责任风险：如您的行为情节严重，构成犯罪的，依法可能追究刑事责任。</b></p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十五、免责声明</p>
    <p><b>15.1 您理解并同意，我们提供的悄然声色产品及服务是按照现有技术和条件所能达到的现状提供的。我们不对下述情形进行任何明示或暗示的保证：</b><br>
    （1）悄然声色产品及服务完全适合您的使用要求、符合特定用途；<br>
    （2）悄然声色产品及服务不受干扰，及时、安全、可靠或不出现任何错误；<br>
    （3）悄然声色产品及服务中任何错误都将能得到更正。</p>
    <p><b>15.2 本平台仅提供声音克隆技术工具及声音交易平台服务，不对用户使用本服务所生成、制作、传播、交易的内容的合法性、真实性、准确性承担任何责任。用户应对其使用本服务的全部行为和后果独立承担全部责任。</b></p>
    <p><b>15.3</b> 我们会尽最大努力确保服务的连贯性和安全性，但产品及服务可能会受多种因素的影响或干扰。您理解并同意，因下述情况导致服务暂停、中止、终止或造成任何损失的，我们在法律法规允许范围内免于承担责任：<br>
    （1）因不可抗力等因素，包括但不限于政府行为、自然灾害（如洪水、地震、台风等）、战争、罢工、骚乱、疫情等；<br>
    （2）因电力故障、通讯网络故障、黑客攻击、恶意程序攻击、病毒、第三方服务瑕疵等我们不能控制的因素；<br>
    （3）我们对产品及服务的相关系统或设备进行检修、维护、升级、保养。</p>
    <p><b>15.4 因您上传、使用、售卖的内容侵犯第三方合法权益而引发的任何纠纷、索赔、诉讼或行政处罚，由您自行承担全部法律责任和经济损失，并应赔偿因此给本平台造成的全部损失。</b></p>
    <p><b>15.5 我们会通过人工智能技术为您提供服务。鉴于现阶段人工智能技术发展不够成熟，存在无法避免的局限性，我们无法完全保证输出内容的真实性、完整性、准确性、及时性及实用性。输出内容仅作为一般信息供您参考，不代表我们的立场，您应对输出内容审慎加以判断并承担因使用输出内容而引起的风险及法律责任。</b></p>
    <p><b>15.6 除法律法规另有明确规定外，在任何情况下，我们对您承担的全部责任，始终不超过您因使用本平台期间而支付给我们的费用（如有）。</b></p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十六、通知</p>
    <p><b>16.1</b> 为给您提供更好的服务，或因国家法律法规、政策调整，技术条件、产品功能等变化需要，我们会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会在官方网站及客户端发出更新版本，并在更新后的条款生效前通过适当的方式提醒您更新的内容。如您继续使用本平台，即表示您已同意接受修订后的本协议内容。如您对修订后的协议内容存有异议的，请立即停止登录或使用本平台。</p>
    <p><b>16.2</b> 我们对您的通知可能会以包括但不限于系统提示、页面弹窗或提示、公告、站内信、电子邮件、手机短信等方式中的一种或多种进行。</p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十七、法律适用与争议解决</p>
    <p><b>17.1 本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。</b></p>
    <p><b>17.2 因本协议引起的或与本协议有关的任何争议，双方应首先友好协商解决；协商不成的，任何一方均可向本平台运营方所在地即北京市海淀区有管辖权的人民法院提起诉讼。</b></p>

    <p style="font-weight: bold; font-size: 15px; margin-top: 20px;">十八、其他</p>
    <p><b>18.1</b> 本协议中的标题仅为方便阅读而设，并不影响本协议中任何约定的含义或解释。</p>
    <p><b>18.2</b> 如果本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
    <p><b>18.3</b> 您和我们均是独立的主体，在任何情况下本协议不构成我们对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。</p>
    <p><b>18.4</b> 本协议未尽事宜，双方应遵守相关法律法规及本平台公布的其他规则、政策。</p>
    
    <p style="margin-top: 15px; text-align: right; font-weight: bold;">
      本协议最终解释权归悄然声色运营方所有。
    </p>
    <p style="text-align: right; color: #666;">
      版本日期：2026年8月17日
    </p>
  </div>
</template>

<script>
export default {
  name: 'UserServiceAgreement',
  components: {},
  props: {},
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.box {
  font-size: 12px;
}
p {
  margin-bottom: 8px;
}
</style>